import { styled } from "@mui/material"

export const TabLabel = styled("span")({
  "&:first-letter": {
    textTransform: "uppercase",
  },
})
